import { queryOptions } from "@tanstack/react-query";
import { GET_CREDIT_PURCHASE_COURSE_INFO } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type { CreditPurchaseCourseInfoResponse } from "~/types/creditPurchaseCourse";

export const creditPurchaseCourseInfoQueryOptions = queryOptions({
  queryKey: queryKeys.creditPurchaseCourse.info(),
  queryFn: () =>
    apiClient<CreditPurchaseCourseInfoResponse>(
      GET_CREDIT_PURCHASE_COURSE_INFO,
    ),
});
